import { createAction, props } from '@ngrx/store';
import { CountryGroup } from './domain/country-group';
import { Country } from './domain/country';
import { Platform } from './domain/platform';
import { UserSegment } from './domain/user-segment';
import { Tenant } from './domain/tenant';
import { Genre } from './domain/genre';
import { CxbActionTriplet } from './core/cxb-action-triplet';
import { Feed } from './domain/feed';
import { AdminUiDetails } from './domain/admin-ui-details';
import { TrayCategoriesApiModel } from '@cxb/editor-stb-api';

const feature = '[CXB App]';

export const setCxbIsLoading = createAction(`${feature} Set loading state explicitly`, props<{ loading: boolean }>());
export const startLoading = createAction(`${feature} Start loading`);
export const finishLoading = createAction(`${feature} Finish loading`);

export const loadCxbUserSegments = createAction(`${feature} Load user segments`);
export const loadCxbUserSegmentsSuccess = createAction(`${feature} Load user segments success`, props<{ userSegments: UserSegment[] }>());
export const loadCxbUserSegmentsFail = createAction(`${feature} Load user segments fail`, props<{ errorMessage: string }>());

export const loadCxbPlatforms = createAction(`${feature} Load platforms`);
export const loadCxbPlatformsSuccess = createAction(`${feature} Load platforms success`, props<{ platforms: Platform[] }>());
export const loadCxbPlatformsFail = createAction(`${feature} Load platforms fail`, props<{ errorMessage: string }>());

export const loadCxbCountries = createAction(`${feature} Load countries`);
export const loadCxbCountriesSuccess = createAction(
  `${feature} Load countries success`,
  props<{ countries: Country[]; countryGroups: CountryGroup[] }>()
);
export const loadCxbCountriesFail = createAction(`${feature} Load counties fail`, props<{ errorMessage: string }>());

export const fetchGenres = createAction(`${feature} Fetch genres`);
export const fetchGenresSuccess = createAction(`${feature} Fetch genres success`, props<{ genres: Genre[] }>());
export const fetchGenresFail = createAction(`${feature} Fetch genres fail`, props<{ errorMessage: string }>());

export const fetchCxbFeeds = CxbActionTriplet.withSuccessProps(`${feature} Fetch feeds`, props<{ feeds: Feed[] }>());

export const loadCxbUserData = createAction(`${feature} Load user data`);
export const loadCxbUserDataSuccess = createAction(
  `${feature} Load user data success`,
  props<{ userId: string; rootLevelRoles: string[]; availableTenants: Tenant[] }>()
);
export const loadCxbUserDataFail = createAction(`${feature} Load user data fail`, props<{ errorMessage: string }>());

export const saveCxbUserSelectedTenant = createAction(`${feature} Set selected tenant`, props<{ tenant: Tenant; userId: string }>());
export const saveCxbUserSelectedTenantSuccess = createAction(
  `${feature} Save the user selected tenant success`,
  props<{ tenant: Tenant }>()
);
export const saveCxbUserSelectedTenantFail = createAction(
  `${feature} Save the user selected tenant fail`,
  props<{ errorMessage: string }>()
);

export const loadCxbUserSelectedTenant = createAction(
  `${feature} Load the user selected tenant`,
  props<{ userId: string; tenantOptions: Tenant[] }>()
);
export const loadCxbUserSelectedTenantSuccess = createAction(
  `${feature} Load the user selected tenant success`,
  props<{ tenant: Tenant }>()
);
export const loadCxbUserSelectedTenantFail = createAction(
  `${feature} Load the user selected tenant fail`,
  props<{ errorMessage: string }>()
);

export const switchCxbTenant = createAction(`${feature} Switch tenant`, props<{ userId: string }>());

// AXB-1194 admin ui details
export const fetchAdminUIDetails = createAction(`${feature} Fetch admin ui details`);
export const fetchAdminUIDetailsSuccess = createAction(
  `${feature} Fetch admin ui details success`,
  props<{ adminUIDetails: AdminUiDetails }>()
);
export const fetchAdminUIDetailsFail = createAction(`${feature} Fetch admin ui details fail`, props<{ errorMessage: string }>());

export const enterTenantIndependentRoute = createAction(`${feature} Enter tenant independent route`);
export const leaveTenantIndependentRoute = createAction(`${feature} Leave tenant independent route`, props<{ tenant: Tenant }>());

export const fetchApiVersion = createAction(`${feature} Fetch api version`);
export const fetchApiVersionSuccess = createAction(`${feature} Fetch api version success`, props<{ version: string }>());
export const fetchApiVersionFail = createAction(`${feature} Fetch api version fail`, props<{ errorMessage: string }>());

export const fetchTrayOptions = createAction(`${feature} Fetch tray options`);
export const fetchTrayOptionsSuccess = createAction(
  `${feature} Fetch tray options success`,
  props<{ trayOptions: TrayCategoriesApiModel }>()
);
export const fetchTrayOptionsFail = createAction(`${feature} Fetch tray options fail`, props<{ errorMessage: string }>());
